import { useQuery } from '@tanstack/react-query';
import {
  getSalesReport,
  getTopProducts,
  getHourlyReport,
  getPreparationTimeReport,
  type SalesReport,
  type TopProductsReport,
  type HourlyReport,
  type PreparationTimeReport,
} from '../services/ReportsService';

export function useSalesReport(from: string, to: string) {
  return useQuery<SalesReport>({
    queryKey: ['reports', 'sales', from, to],
    queryFn: () => getSalesReport(from, to),
    enabled: !!from && !!to,
    staleTime: 60_000,
  });
}

export function useTopProducts(from: string, to: string, limit = 10) {
  return useQuery<TopProductsReport>({
    queryKey: ['reports', 'top-products', from, to, limit],
    queryFn: () => getTopProducts(from, to, limit),
    enabled: !!from && !!to,
    staleTime: 60_000,
  });
}

export function useHourlyReport(date: string) {
  return useQuery<HourlyReport>({
    queryKey: ['reports', 'hourly', date],
    queryFn: () => getHourlyReport(date),
    enabled: !!date,
    staleTime: 60_000,
  });
}

export function usePreparationTimeReport(from: string, to: string) {
  return useQuery<PreparationTimeReport>({
    queryKey: ['reports', 'preparation-time', from, to],
    queryFn: () => getPreparationTimeReport(from, to),
    enabled: !!from && !!to,
    staleTime: 60_000,
  });
}
